import BaseMove from "./base-move";
import {ActionTypeEnum} from "../../base/training-literals";

class MoveGroup extends BaseMove {
    modelId;
    groupName;

    constructor(props = {}) {
        super(props);
        this.actionType = ActionTypeEnum.MOVE_GROUP;
        this.modelId = props.modelId || "";
        this.groupName = props.groupName || "";
    }

    get(props = {}) {
        return {
            type: this.actionType,
            modelId: props.modelId || this.modelId,
            groupName: props.groupName || this.groupName,
            animateMovement: props.animateMovement || this.animateMovement,
            animateTime: props.animateTime || this.animateTime,
            position: props.position || this.position,
            quaternion: props.quaternion || this.quaternion,
            scale: props.scale || this.scale,
            duration: props.duration || this.duration
        }
    }

    startModelSelectionCallback(itemArr) {
        const actionId = itemArr[0];
        if (!this.shouldExecute(actionId)) return;

        this.startSelectionForMove();
    }

    startSelectionForMove() {
        this.startModelSelection = true;
        const applyToType = CatchTargetTypeEnum.GROUP;
        VRMessageController.addMessage({
            text: "Select a volume present in a group to perform move group.",
            priority: VrMessagePriorityEnum.LOWPRIORITYINFO
        });

        super.startSelectionForMove(applyToType);
    }

    selectEntityForEditingMove(entityName) {
        entityName = entityName[0];
        this.cancelSelection = false;
        let groupData = GroupData.getGroupByName(entityName) || GroupData.getGroupById(entityName);
        let volumeNames = groupData.getValidVolumeBranchIds();
        this.startModelSelection = true;
        this.set2dElementsVisibility(false);
        CatchVolumeFeatureController.onChangeMoveFeature(true);
        CatchVolumeFeatureController.onSelectApplyToType(CatchTargetTypeEnum.GROUP);
        GroupController.setVolumeListForIndividualGroupMove(volumeNames[0]);
        catchBody(undefined, undefined, undefined, undefined, {groupIdList: [groupData.id]});
        this.startModelSelection = false;
    }

    recordDataOnCatchBody(caughtVolume) {
        const groupData = GroupData.getGroupById(caughtVolume.groupIdList[0]);

        MoveObjectActionController.modelId = caughtVolume.model.id;
        MoveObjectActionController.modelName = caughtVolume.model.name;
        MoveObjectActionController.groupId = groupData ? groupData.id : undefined;
        MoveObjectActionController.groupName = groupData ? groupData.name : undefined;
    }

    getData() {
        let firstVolumeLocalMatrix = new THREE.Matrix4();
        if (MoveObjectActionController.modelId && MoveObjectActionController.groupId) {
            const group = GroupData.getGroupById(MoveObjectActionController.groupId);
            firstVolumeLocalMatrix = getVolumeLocalMatrix(MoveObjectActionController.modelId, group.volumes[0].branchId).clone();
        }

        let position = new THREE.Vector3();
        let quaternion = new THREE.Quaternion();
        let scale = new THREE.Vector3();
        firstVolumeLocalMatrix.decompose(position, quaternion, scale);

        return {
            position: position.toArray(),
            quaternion: quaternion.toArray(),
            scale: scale.toArray()
        };
    }

    catchObjectToMove() {
        CatchVolumeFeatureController.onSelectApplyToType(CatchTargetTypeEnum.GROUP);
        catchBody(undefined, undefined, undefined, undefined,
            {groupIdList: [MoveObjectActionController.groupId]});
    }
}

export default MoveGroup;